// Copyright (c) Ping. All rights reserved.
//
// Web variant of the New chat / New group / Add-menu icons. Encodes the
// parametrised SVG as a `data:image/svg+xml;base64,…` URI fed to `<Image>`
// (react-native-svg has no web runtime). macOS uses the `.macos.tsx`
// sibling. Mirrors `icons/NavIcon.tsx` / `chat/MediaPreviewIcon.tsx`.

import { Image } from 'react-native';
import { getNewChatIconSvg, type NewChatIconName } from './newChatIconSvgs';

export interface NewChatIconProps {
  readonly name: NewChatIconName;
  readonly size?: number;
  readonly color?: string;
  readonly accessibilityLabel?: string;
}

export function NewChatIcon({
  name,
  size = 16,
  color = '#E8EAED',
  accessibilityLabel,
}: NewChatIconProps): JSX.Element {
  const svg = getNewChatIconSvg(name, color);
  const uri =
    typeof btoa !== 'undefined'
      ? `data:image/svg+xml;base64,${btoa(svg)}`
      : `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  return (
    <Image
      source={{ uri }}
      accessibilityIgnoresInvertColors
      accessibilityLabel={accessibilityLabel ?? name}
      style={{ width: size, height: size }}
      resizeMode="contain"
    />
  );
}
